<template>
    <div class="bigBox">
        <div class="logoBox">
            <div style="float: left;height: 100%;display: flex;align-items: center;margin: 0px 35px">
                <img :src="userData.pc_logo" alt="" style="width: 160px;">
            </div>
            <div class="otherPages">
                <a  :href="agent" target="_blank" style="color: #ffffff" v-if="userData.platform_sn == 2">
                    登录案件管理端
                </a>
                <a  :href="agent" target="_blank" style="color: #ffffff" v-else>
                    登录代理人端
                </a>
<!--                <p>我是仲裁委</p>-->
<!--                <p>我是公证处</p>-->
            </div>
        </div>
        <div class="loginBox">
            <div class="login">
                <div class="systematicName" v-if="userData.platform_sn == 2">
                    <p>杭易达系统</p>
                    <span>用户端</span>
                </div>
                <div class="systematicName" v-else>
                    <p>案件管理系统</p>
                    <span>企业端</span>
                </div>
                <!--        验证码 密码切换-->
                <div style="width: 100%">
                    <div class="outer-div">
                        <header class="header">
                            <ul class="tab-tilte">
                                <li :class="{ active: tab == 0 }" @click="tab = 0">验证码登录</li>
                                <li :class="{ active: tab == 1 }" @click="passwordBtn">密码登录</li>
                            </ul>
                        </header>

                        <div class="tab-content">
                            <div v-show="tab == 0" v-if="tab==0">
                                <el-form :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
                                    <el-form-item prop="phone">
                                        <el-input v-model="ruleForm.phone" placeholder="请输入手机号" maxlength="11"
                                                  oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                    </el-form-item>
                                    <el-form-item prop="img_code">
                                        <div style="display: flex;">
                                            <el-input v-model="ruleForm.img_code" placeholder="请输入图形验证号" maxlength="4"
                                                      oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                            <img style="height: 45px" :src="figure.src" @click="changeOver" alt="">
                                        </div>
                                    </el-form-item>
                                    <el-form-item prop="validation">
                                        <div style="display: flex;">
                                            <el-input v-model="ruleForm.validation" placeholder="请输入验证号" maxlength="6"
                                                      oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
                                            <el-button @click="getCodes" :disabled="disadles">{{ msgText }}</el-button>
                                        </div>
                                    </el-form-item>
                                </el-form>
                                <div class="remember">
                                    <!--                                    <el-checkbox v-model="checked">记住密码</el-checkbox>-->
                                    <div @click="submitForm">登录</div>
                                </div>
                                <!--                                <div class="forget">忘记密码？</div>-->
                                <div class="registered">
                                    <p>还没有账号？</p>
                                    <span @click="goRegister">立即注册</span>
                                </div>
                            </div>
                            <div v-show="tab == 1" v-if="tab==1">
                                <passwordPages :tab="tab"></passwordPages>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 备案号 -->
        <div class="footer-beian">
            <p v-if="userData.platform_sn == 684920348"><a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备2026044333号</a></p>
            <p v-else><a href="https://beian.miit.gov.cn/" target="_blank">{{ userData.icp_sn }}</a></p>
        </div>
        <!--        右侧电话咨询栏-->
        <!--        <div class="rightFixedBox">
        <!--            <aside class="sidebar">-->
        <!--                &lt;!&ndash;                电话咨询&ndash;&gt;-->
        <!--                <div style="background-color: #2d8cf0;border-radius:5px">-->
        <!--                    <img src="../../assets/img/telephone.png"/>-->
        <!--                    <h3>电话咨询</h3>-->
        <!--                    <div class="code">-->
        <!--                        <div>-->
        <!--                            <p>咨询电话</p>-->
        <!--                            <span>400-0311-272</span>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;                微信咨询&ndash;&gt;-->
        <!--                <div style="background-color: #2d8cf0;border-radius:5px">-->
        <!--                    <img src="../../assets/img/wxlogo.png"/>-->
        <!--                    <h3>微信咨询</h3>-->
        <!--                    <div class="code">-->
        <!--                        <img src="../../assets/img/wxcode.png"/>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--                &lt;!&ndash;                公众号&ndash;&gt;-->
        <!--                <div style="background-color: #2d8cf0;border-radius:5px">-->
        <!--                    <img src="../../assets/img/publiclogo.png"/>-->
        <!--                    <h3>公众号</h3>-->
        <!--                    <div class="code">-->
        <!--                        <img src="../../assets/img/publiccode.jpg"/>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </aside>-->
        <!--        </div>-->
    </div>
</template>

<script>
    import passwordPages from './components/password';
    import { figureVerification, validation, verifyLogin } from '../../api/login';
    import { parseQuery } from '../../utils/parsing';

    export default {
        name: 'login',
        data() {
            return {
                agent:  '',  //代理人端
                userData: '',
                param: {
                    username: 'admin',
                    password: '123123'
                },
                logoImg: '',
                figure: {},
                tab: '0',
                phone: '', //手机号
                validation: '', //验证码
                disadles: false,
                count: 60,
                msgText: '获取验证码',
                checked: false,  //记住密码
                ruleForm: {
                    phone: '', //账号
                    validation: '', // 验证码
                    password: '',  // 密码
                    confirm: '',  //确认密码
                    img_code: ''
                },
                rules: {
                    phone: [
                        { required: true, message: '请输入手机号', trigger: 'blur' },
                        { min: 11, max: 11, message: '请输入正确的手机号', trigger: 'blur' }
                    ],
                    img_code: [
                        { required: true, message: '请输入图形验证码', trigger: 'blur' }
                    ],
                    validation: [
                        { required: true, message: '请输入验证码', trigger: 'blur' },
                        { min: 6, max: 6, message: '请输入正确的验证码', trigger: 'blur' }
                    ]
                }
            };
        },
        methods: {
            fn_Guid() {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
                    var r = Math.random() * 16 | 0,
                        v = c == 'x' ? r : (r & 0x3 | 0x8);
                    return v.toString(16);
                });
            },
            //获取验证码
            getCodes() {
                validation(this.ruleForm.img_code, this.figure.uniqid, this.ruleForm.phone, 2).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg);
                        let times = 60;
                        let setInter = setInterval(() => {
                            times--;
                            if (times <= 0) {
                                this.msgText = '获取验证码';
                                this.disadles = false;
                                clearInterval(setInter);
                            } else {
                                this.msgText = '重新获取(' + times + ')';
                                this.disadles = true;
                            }
                        }, 1000);
                    } else if (res.code == 400) {
                        this.$message.error(res.msg);

                    } else {
                        this.$message.error('验证码获取失败，请联系管理员');

                    }
                });

            },
            //登录
            submitForm() {
                verifyLogin(this.ruleForm.phone, this.ruleForm.validation).then(res => {
                    if (res.code == 200) {
                        sessionStorage.setItem('token', res.data.token);
                        this.$message.success('登录成功');
                        this.$router.push('/index');
                    } else if (res.code == 400) {
                        this.$message.error(res.msg);
                    } else {
                        this.$message.error(res.msg);

                    }
                });
                // this.$router.push('/');
            },
            //注册
            goRegister() {
                this.$router.push('/registered');
            },
            changeOver() {
                this.figure.src = this.figure.src + '?=' + Math.random();
            },
            keyDown(e) {
                if (this.tab == 0) {
                    if (e.keyCode === 13) {
                        this.submitForm();
                    }
                }
            },
            passwordBtn() {
                this.tab = 1;
            }
        },
        // 绑定监听事件
        mounted() {
            window.addEventListener('keydown', this.keyDown);
        },
        // 销毁事件
        destroyed() {
            window.removeEventListener('keydown', this.keyDown, false);
        },
        components: {
            passwordPages
        },
        created() {
            this.logoImg = JSON.parse(localStorage.getItem('logo'));
            this.userData = JSON.parse(localStorage.getItem('userData'));
            if( this.userData.category==2 ){
                this.agent = `/agent/#/?mark=${this.userData.category_mark}`
            }else{
                this.agent = `/agent`
            }

            if (!sessionStorage.unid) {
                sessionStorage.setItem('unid', this.fn_Guid());
            }
            figureVerification(sessionStorage.unid).then(res => {
                res.data.src = res.data.src + '?=' + Math.random();
                this.figure = res.data;
            });
        }
    };
</script>

<style scoped>
    /*    logo*/
    .logoBox {
        width: 80%;
        margin: auto;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

    }

    .otherPages {
        width: 400px;
        display: flex;
        justify-content: flex-end;
        color: #fff;
    }

    /*    登录框*/
    .loginBox {
        width: 400px;
        height: 600px;
        margin-top: 70px;
        background-color: #fff;
        border-radius: 10px;
        /*border: 1px solid black;*/
        box-shadow: 5px 10px 10px -5px #dedede;
        margin-right: 150px;
        float: right;
    }

    .login {
        width: 80%;
        margin: 30px auto;
    }

    .systematicName {
        display: flex;
        align-items: flex-end;
    }

    .systematicName > P {
        margin-right: 20px;
        font-size: 28px;
        color: #1e57dc;
        font-weight: 600;
    }

    .systematicName > span {
        font-size: 16px;
        color: #194ec9;
        font-weight: 600;
    }

    .outer-div {
        padding: 24px;
        margin: 0 auto;
    }

    .header {
        height: 54px;
        width: 100%;
        border-bottom: 1px solid #ebebeb;
        margin-bottom: 24px;
    }

    ul li {
        margin: 0;
        padding: 0;
        list-style: none;
    }

    .tab-tilte {
        font-family: PingFangSC-Semibold;
        letter-spacing: 0;
        width: 90%;
    }

    .tab-tilte li {
        width: 120px;
        border-radius: 5px;
        border: 0.5px solid #e2e4ee;
        float: left;
        color: #727273;
        line-height: 45px;
        text-align: center;
        margin-right: 15px;
        cursor: pointer;

    }

    /* 点击对应的标题添加对应的背景颜色 */
    .tab-tilte .active {
        color: #fff;
        /*border-bottom: 2px solid #3385ff;*/
        box-shadow: 5px 10px 10px -5px #b9c6fc;
        background-color: #3d62f6;
    }

    .header {
        background-color: transparent !important;
        border: transparent;
    }

    .outer-div {
        padding: 24px 5px;
    }

    /deep/ .el-input__inner {
        margin-bottom: 10px;
        height: 45px;
    }

    /deep/ .el-button {
        height: 45px;
    }

    /deep/ .el-button--small,
    /deep/ .el-button {
        color: #3d62f6 !important;
    }

    /*记住密码*/
    /deep/ .el-checkbox__inner {
        border-radius: 45%;
    }

    .remember {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .remember > div {
        cursor: pointer;
        width: 90%;
        height: 40px;
        background: #3d62f6;
        border-radius: 5px;
        color: #fff;
        text-align: center;
        line-height: 40px;
        margin: 20px auto;
    }

    .registered {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 45px;
        background-color: #fcfdfe;
        border: 0.5px solid #dde0eb;
        margin: 20px auto;
    }

    .registered > p {
        color: #8b8b8b;
    }

    .registered > span {
        color: #3d62f6;
        cursor: pointer;
    }

    /deep/ .el-form-item__content {
        width: 100%;
        margin: auto !important;

    }

    .rightFixedBox {
        height: 200px;
        width: 70px;
        /*background-color: pink;*/
        position: fixed;
        bottom: 50px;
        right: 10px;
    }

    /*    右侧*/
    .sidebar {
        position: fixed;
        z-index: 88;
        right: 10px;
    }

    .sidebar > div {
        padding: 5px;
        cursor: pointer;
        text-align: center;
        position: relative;
        margin-bottom: 10px;
        transition: all .4s;
    }

    .sidebar > div:hover {
        transform: scale(1.1);
    }

    .sidebar > div img {
        width: 20px;
    }

    .sidebar > div h3 {
        font-size: 14px;
        font-weight: 500;
        color: #fff;
    }

    .sidebar > div .code {
        display: none;
        position: absolute;
        z-index: 9;
        top: 0;
        right: 110%;
        border-radius: 8px;
        box-shadow: 0 6px 12px 0 rgba(106, 115, 133, 0.22);
        background-color: #ffffff;
        padding: 10px;
    }

    .sidebar > div .code img {
        width: 100px;
    }

    .sidebar > div .code:after {
        position: absolute;
        height: 30px;
        top: 30px;
        left: 100%;
        content: "";
        transform: translateY(-50%);
        border-width: 5px;
        border-style: solid;
        border-color: transparent;
    }

    .sidebar > div:hover .code {
        display: block;
    }

    .code > div {
        width: 120px;
    }

    .code p {
        font-size: 12px;
        color: #666666;
    }

    .code span {
        font-size: 14px;
        color: #ff0000;
    }

    /* 备案号样式 */
    .footer-beian {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        padding: 15px 0;
        text-align: center;
        background-color: transparent;
    }

    .footer-beian p {
        font-size: 14px;
        color: #999;
        margin: 0;
    }
    .footer-beian p a {
        color: #999;
        text-decoration: none;
    }
</style>
